import { liveUpdateAttrs } from '@/libs/contentful/utils';
import { cn } from '@/utils/styles';
import { Options } from '@contentful/rich-text-react-renderer';
import RichTextHeadline from '../shared/RichTextHeadline/RichTextHeadline';
import { SplitRichTextHeadlineProps } from './types';

const SplitRichTextHeadline = ({ sys, headline, isExpanded }: SplitRichTextHeadlineProps) => {
  const internalClassNames = {
    wrapper: cn('font-sans font-semibold text-heading-sm md:text-heading-lg tracking-[-0.036em] break-all', {
      'sm:text-[1.75rem] sm:font-[570]': !isExpanded,
    }),
    preamble: cn('text-[1.31rem] leading-[1.25]'),
    callout: cn('text-[2.38rem] leading-[1]'),
  };

  const additionalOptions: Options = {
    renderText: text => {
      if (!isExpanded) {
        return text;
      }
      const [head, ...tail] = text.split(' ');

      return (
        <span>
          <span className={internalClassNames.preamble}>{head}</span>
          <br data-testid="headline-break" />
          <span className={internalClassNames.callout}>{tail.join(' ')}</span>
        </span>
      );
    },
  };

  return (
    <div className={cn(internalClassNames.wrapper)} {...liveUpdateAttrs(sys?.id, 'headline')}>
      <RichTextHeadline headline={headline} additionalOptions={additionalOptions} />
    </div>
  );
};

export default SplitRichTextHeadline;
